import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { subscriptionAPI } from '../services/api';
import './SubscriptionSelection.css';

/**
 * Simplified subscription flow - auto-starts free trial
 * Full tier selection UI is preserved but hidden for future use
 */
const SubscriptionSelection: React.FC = () => {
  const [isLoading, setIsLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);
  const navigate = useNavigate();

  useEffect(() => {
    startFreeTrial();
  }, []);

  const startFreeTrial = async () => {
    try {
      setIsLoading(true);
      setError(null);

      // Try to assign free tier automatically
      await subscriptionAPI.assignFreeTier();

      // Straight to dashboard. The knowledge check is surfaced there via the
      // KC nudge banner when ready — we don't force it into the signup path.
      navigate('/dashboard');
    } catch (err: any) {
      console.error('Error starting free trial:', err);
      // If it fails, still redirect to dashboard (user might already have a subscription)
      navigate('/dashboard');
    }
  };

  if (error) {
    return (
      <div className="subscription-selection-page error">
        <div className="error-icon">⚠️</div>
        <h2>Something went wrong</h2>
        <p>{error}</p>
        <button onClick={startFreeTrial} className="retry-button">
          Try Again
        </button>
      </div>
    );
  }

  return (
    <div className="subscription-selection-page loading">
      <div className="spinner"></div>
      <p>Setting up your account...</p>
    </div>
  );
};

export default SubscriptionSelection;
